import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["title"];
import * as React from 'react';
export default (function (_ref) {
  var title = _ref.title,
    extra = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement("svg", _extends({
      height: "39.05",
      width: "50",
      viewBox: "0 0 50 39.05"
    }, extra), title, /*#__PURE__*/React.createElement("path", {
      d: "M43.492 0H6.508A6.48 6.48 0 0 0 0 6.51v26.033a6.481 6.481 0 0 0 6.508 6.508h36.984A6.48 6.48 0 0 0 50 32.541V6.508A6.481 6.481 0 0 0 43.492 0zM6.508 3.62h36.984a2.888 2.888 0 0 1 2.893 2.893v4.442H3.615V6.513c0-1.653 1.24-2.893 2.893-2.893zm36.984 31.82H6.508a2.888 2.888 0 0 1-2.893-2.893V18.291h42.873v14.256c0 1.55-1.343 2.893-2.996 2.893z"
    }))
  );
});